import React from "react";
import { graphql } from "gatsby";
import { get } from "lodash";
import { Div } from "atomize";

import Header from "../components/common/Header";

import Layout from "../components/common/layout";
import MarketingHero from "../components/marketing/MarketingHero";
import SolutionsFooter from "../components/common/SolutionsFooter";
import MarketingBigButton from "../components/marketing/MarketingBigButton";
import Footer from "../components/common/Footer";
import SEO from "../components/seo";

const marketing = ({ data }) => {
  const page = data.contentfulMarketingPage;

  return (
    <Layout>
      <Header headerFixed={true} data={{ contentfulJson: data.headerJson }} />
      <SEO seo={page.seo} url={`https://trend.io/${page.slug}`} />
      <MarketingHero
        title={page.title}
        content={page.content.json}
        brands={page.brands}
        form={page.form.form}
        formTitle={page.formTitle.formTitle}
      />
      <Div m={{ t: "5rem" }}>
        <SolutionsFooter content={page} />
      </Div>
      <Div m={{ t: "6.875rem" }}>
        <MarketingBigButton link={page.btnLink} />
      </Div>
      <Footer
        contentfulFooter={data.contentfulFooter}
        contentfulGlobalConfig={data.contentfulGlobalConfig}
      />
    </Layout>
  );
};

export default marketing;

export const query = graphql`
  query($slug: String!) {
    contentfulFooter(contentful_id: { eq: "5noUnCCOBDl8Is2Ppw2Nty" }) {
      solutions {
        label
        link
        isExternal
      }
      menu {
        label
        link
        isExternal
      }
      links {
        label
        link
        isExternal
      }
      instagramLink
      logoLink
    }

    contentfulGlobalConfig {
      footerForm {
        footerForm
      }
    }

    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }

    contentfulMarketingPage(slug: { eq: $slug }) {
      slug
      title
      brandImage {
        brandImage
      }
      form {
        form
      }
      formTitle {
        formTitle
      }

      brands {
        file {
          url
        }
        description
      }
      cards {
        heading
        text
        color
        btnText
        link
      }
      content {
        json
      }
      btnLink
      seo {
        ...SeoFragment
      }
    }
  }
`;
